import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// Helpers
import { toggleDrawer } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';
import Drawer from '../Drawer/Drawer.js';


const Users = observer(class Users extends React.Component {
  constructor() {
    super();
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      userSid: null
    }

  }

  componentDidMount() {
    const { pathname } = this.props.routing.location;

    const { EnrollmentStore, SessionStore } = this.props.store;

    if(!SessionStore.userData.isSuperAdmin) {
      this.props.routing.history.push('/unauthorized')
    }

    EnrollmentStore.listProctorUsers();

    this.setState({
      userSid: null
    })

    if(pathname.indexOf('/edit') > -1) {
      const userSid = pathname.substr(pathname.lastIndexOf('/') + 1);

      this.setState({
        userSid
      });
      toggleDrawer(null, this, 'UserEdit')
    } else if(pathname.indexOf('/add') > -1) {
      this.setState({
        userSid: null
      })
      toggleDrawer(null, this, 'CreateUser');
  }
  }

  handleEdit(e, userSid) {
    e.preventDefault();

    // Update url
    let path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');

    if(this.props.routing.location.pathname !== path) {
      this.props.routing.history.push(path);
    }
    // Reset userSid data
    this.setState({
      userSid: null
    });
  }

  handleNew(e) {
    e.preventDefault();

    // Reset userSid data
    this.setState({
      userSid: null
    });

    // Update url
    let path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');

    if(this.props.routing.location.pathname !== path) {
      this.props.routing.history.push(path);
    }
  }

  render() {
    const { store, translation } = this.props;
    const { EnrollmentStore } = store;
    const { proctorUsers } = EnrollmentStore;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <div className="wrap">
          <header className="page__header">
            <div className="wrap">
              <h1 className="page__title">{translation.users}</h1>

              <div className="page__actions actions">
                <Link className="btn--outline" to="/users/add" onClick={(e) => {this.handleNew(e)}}>
                  <icons.iconPlus />
                  {translation.new_user}
                </Link>
              </div>
            </div>
          </header>

          {proctorUsers && proctorUsers.length > 0 &&
            <table className="panel">
              <thead>
                <tr>
                  <th scope="col">{translation.first_name}</th>
                  <th scope="col">{translation.last_name}</th>
                  <th scope="col">{translation.email}</th>
                  <th scope="col"></th>
                </tr>
              </thead>

              <tbody>
                {proctorUsers.map(
                  (user, i) => {
                    if(!user.isSuperAdmin){
                      return(
                      <tr key={i}>
                        <td>{user.firstName}</td>
                        <td>{user.lastName}</td>
                        <td>{user.email}</td>
                        <td className="actions">
                        <Link
                          className="btn--outline"
                          to={`/users/edit/${user.sid}`}
                          onClick={(e) => this.handleEdit(e, user.sid)}
                        >
                          {translation.edit}
                        </Link>
                        </td>
                      </tr>)
                    }
                    return null;
                  }
                )}
              </tbody>
            </table>
          }
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this} {...this.props}
          userSid={this.state.userSid}
        />
      </main>
    )
  }
})

export default translate('Users')(Users);


// WEBPACK FOOTER //
// ./src/app/components/Users/Users.js